module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxn1XrJsKtwhNaJmMXegB1eg.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/PRmiXeptR36kaC0GEAetxn1XrJsKtwhNaJmMXegB1eg.woff2
// module id = 415
// module chunks = 0